import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import axios from "axios";
require("dotenv/config");

Vue.config.productionTip = false;

const axiosInstance = axios.create({
  baseURL: process.env.VUE_APP_BASE_URL
});
Vue.prototype.$http = axiosInstance;

const axiosStaging = axios.create({
  baseURL: process.env.VUE_APP_TEST_URL
});
Vue.prototype.$shttp = axiosStaging;

router.beforeEach((to, from, next) => {
  if (!to.matched.length) {
    next("/not-found");
  } else {
    next();
  }
});

new Vue({
  router,
  store,
  vuetify,
  render: (h) => h(App)
}).$mount("#app");
